<template>
    <CompassMenu
        placement="top-start"
        trigger="click"
        custom-class="custom-menu-container"
        :disabled="disabled"
    >
        <CompassTooltip
            :content="$t.__(getExtensionOption(option).label)"
            placement="top"
            :delay="{ show: 0, hide: 1 }"
            :disabled="disabled"
        >
            <SelectRichText
                :label="$t.__(getExtensionOption(option).label)"
                :disabled="disabled"
                :active="activeStyle(option)"
            />
        </CompassTooltip>
        <template slot="dropdown">
            <CompassMenuItem
                class="custom-menu-item"
                @click="getExtensionOption('Unformat').action()"
            >
                <span class="typographies-paragraph-small-regular">
                    {{ $t.__(getExtensionOption('Paragraph').label) }}
                </span>
                <span class="option-shortcuts-menu">
                    {{ $t.__(getExtensionOption('Unformat').shortcuts) }}
                </span>
            </CompassMenuItem>
            <CompassMenuItem
                class="custom-menu-item"
                @click="getExtensionOption('Blockquote').action()"
            >
                <span class="typographies-paragraph-small-regular">
                    {{ $t.__(getExtensionOption('Blockquote').label) }}
                </span>
                <span class="option-shortcuts-menu">
                    {{ $t.__(getExtensionOption('Blockquote').shortcuts) }}
                </span>
            </CompassMenuItem>
            <CompassMenuItem class="custom-menu-item" @click="getExtensionOption('Code').action()">
                <span class="typographies-paragraph-small-regular">
                    {{ $t.__(getExtensionOption('Code').label) }}
                </span>
                <span class="option-shortcuts-menu">
                    {{ $t.__(getExtensionOption('Code').shortcuts) }}
                </span>
            </CompassMenuItem>
            <CompassMenuItem
                class="custom-menu-item"
                @click="getExtensionOption('Heading1').action()"
            >
                <h1 class="typographies-heading-h1 heading">
                    {{ $t.__(getExtensionOption('Heading1').label) }}
                </h1>
                <span class="option-shortcuts-menu">
                    {{ $t.__(getExtensionOption('Heading1').shortcuts) }}
                </span>
            </CompassMenuItem>
            <CompassMenuItem
                class="custom-menu-item"
                @click="getExtensionOption('Heading2').action()"
            >
                <h2 class="typographies-heading-h2 heading">
                    {{ $t.__(getExtensionOption('Heading2').label) }}
                </h2>
                <span class="option-shortcuts-menu">
                    {{ $t.__(getExtensionOption('Heading2').shortcuts) }}
                </span>
            </CompassMenuItem>
            <CompassMenuItem
                class="custom-menu-item"
                @click="getExtensionOption('Heading3').action()"
            >
                <h3 class="typographies-heading-h3 heading">
                    {{ $t.__(getExtensionOption('Heading3').label) }}
                </h3>
                <span class="option-shortcuts-menu">
                    {{ $t.__(getExtensionOption('Heading3').shortcuts) }}
                </span>
            </CompassMenuItem>
            <CompassMenuItem
                class="custom-menu-item"
                @click="getExtensionOption('Heading4').action()"
            >
                <h4 class="typographies-heading-h4 heading">
                    {{ $t.__(getExtensionOption('Heading4').label) }}
                </h4>
                <span class="option-shortcuts-menu">
                    {{ $t.__(getExtensionOption('Heading4').shortcuts) }}
                </span>
            </CompassMenuItem>
            <CompassMenuItem
                class="custom-menu-item"
                @click="getExtensionOption('Heading5').action()"
            >
                <h5 class="typographies-heading-h5 heading">
                    {{ $t.__(getExtensionOption('Heading5').label) }}
                </h5>
                <span class="option-shortcuts-menu">
                    {{ $t.__(getExtensionOption('Heading5').shortcuts) }}
                </span>
            </CompassMenuItem>
            <CompassMenuItem
                class="custom-menu-item"
                @click="getExtensionOption('Heading6').action()"
            >
                <h6 class="typographies-heading-h6 heading">
                    {{ $t.__(getExtensionOption('Heading6').label) }}
                </h6>
                <span class="option-shortcuts-menu">
                    {{ $t.__(getExtensionOption('Heading6').shortcuts) }}
                </span>
            </CompassMenuItem>
        </template>
    </CompassMenu>
</template>

<script>
import OptionsRichTextMixin from 'mixins/OptionsRichTextMixin';
import SelectRichText from 'vcomponents/richtext/customoptions/SelectRichText.vue';

export default {
    name: 'HeadingRichText',
    components: {
        SelectRichText,
    },
    mixins: [OptionsRichTextMixin],
};
</script>
